// import React, { PureComponent } from 'react';
/* eslint-disable jsx-a11y/label-has-associated-control */
import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import { useTheme } from '../../../theme-context';
import ProgressIndicatorLinear from '../progress-indicator-linear/progress-indicator-linear';

const UnitsAvailable = ({
    total,
    available,
}: {
    total: number;
    available: number;
}) => {
    const { getFont, styles } = useTheme();
    const percent = Math.floor((100 * available) / total);

    return (
        <div
            className={css({
                width: '100%',
                // width: 'fit-content',
            })}
        >
            <div
                className={css({
                    marginBottom: '8px',
                    width: '100%',
                })}
            >
                <span
                    className={css({
                        fontFamily: getFont('desktop/body/medium').fontFamily,
                        fontWeight: getFont('desktop/body/medium').fontWeight,
                        fontSize: getFont('desktop/body/medium').fontSize,
                        color: styles.colors['grey-07'].color,
                        lineHeight: `${
                            getFont('desktop/body/medium').lineHeightPx
                        }px`,
                        marginRight: '48px',
                    })}
                    data-testid="units-available-label"
                >
                    {gettext('Units available')}
                </span>
                <span
                    className={css({
                        textAlign: 'right',
                        float: 'right',
                        minWidth: '90px',
                        fontFamily: getFont('desktop/body/medium/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/medium/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/medium/bold').fontSize,
                        lineHeight: `${
                            getFont('desktop/body/medium/bold').lineHeightPx
                        }px`,
                        color: styles.colors['grey-07'].color,
                    })}
                >
                    {available}/{total} ({percent}%)
                </span>
            </div>
            <div>
                <ProgressIndicatorLinear percent={percent} />
            </div>
        </div>
    );
};

export default UnitsAvailable;
